/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityByCloudAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityByCloudAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityByCloudAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityByCloudAccountWidgetConfiguration>): VulnerabilityByCloudAccountWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityByCloudAccountWidgetConfiguration(), model);
        VulnerabilityByCloudAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityByCloudAccountWidgetConfiguration>): VulnerabilityByCloudAccountWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityByCloudAccountWidgetConfiguration.newInstance(<VulnerabilityByCloudAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityByCloudAccountWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityByCloudAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityByCloudAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityByCloudAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
